import { LoadingSpinner } from '../../../../../atoms/LoadingSpinner'

export const EditorLoader = ({ height }: { height?: number }) => (
  <div
    className='flex items-center justify-center rounded-lg border border-borderPrimary bg-backgroundSecondary'
    style={{ height: `${height ?? 20}rem` }}
  >
    <LoadingSpinner size='lg' />
  </div>
)
